// ไฟล์: frontend/src/pages/admin/AdminInnovationsPage.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import "moment/locale/th";
import "../admin/AdminPages.css";
import AdminSidebar from "../../components/layout/AdminSidebar";


const AdminInnovationsPage = ({ user }) => {
  const [pendingInnovations, setPendingInnovations] = useState([]);
  const [approvedInnovations, setApprovedInnovations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("pending");
  const [selectedInnovation, setSelectedInnovation] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  // ตั้งค่าภาษาไทยสำหรับ moment
  moment.locale("th");

  // ดึงข้อมูลนวัตกรรมทั้งหมด
  useEffect(() => {
    fetchInnovations();
  }, []);

  // ฟังก์ชันดึงข้อมูลนวัตกรรม
  //   const fetchInnovations = async () => {
  //     setLoading(true);
  //     try {
  //       // ดึงนวัตกรรมทั้งหมด
  //       const response = await axios.get('/innovations');

  //       // แยกนวัตกรรมที่รอการอนุมัติและที่อนุมัติแล้ว
  //       const pending = response.data.innovations.filter(innovation => !innovation.is_approved);
  //       const approved = response.data.innovations.filter(innovation => innovation.is_approved);

  //       setPendingInnovations(pending);
  //       setApprovedInnovations(approved);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error('Error fetching innovations:', error);
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'เกิดข้อผิดพลาด',
  //         text: 'ไม่สามารถดึงข้อมูลนวัตกรรมได้'
  //       });
  //       setLoading(false);
  //     }
  //   };
  // แก้ไขในไฟล์: frontend/src/pages/admin/AdminInnovationsPage.js

  // แก้ไขฟังก์ชัน fetchInnovations
  const fetchInnovations = async () => {
    setLoading(true);
    try {
      // เพิ่ม console.log เพื่อตรวจสอบการทำงาน
      console.log("Fetching innovations data...");

      // ดึงข้อมูลทั้งหมดโดยใช้พารามิเตอร์ showAll=true
      const response = await axios.get("/innovations?showAll=true");
      console.log("Innovations data:", response.data);

      // แยกนวัตกรรมที่รอการอนุมัติและที่อนุมัติแล้ว
      const pending = response.data.innovations.filter(
        (innovation) => !innovation.is_approved
      );
      const approved = response.data.innovations.filter(
        (innovation) => innovation.is_approved
      );

      console.log("Pending innovations:", pending.length);
      console.log("Approved innovations:", approved.length);

      setPendingInnovations(pending);
      setApprovedInnovations(approved);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching innovations:", error);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: "ไม่สามารถดึงข้อมูลนวัตกรรมได้",
      });
      setLoading(false);
    }
  };

  // ฟังก์ชันอนุมัตินวัตกรรม
  const handleApprove = async (id) => {
    try {
      const response = await axios.put(`/innovations/${id}/approve`);

      Swal.fire({
        icon: "success",
        title: "สำเร็จ!",
        text: "อนุมัตินวัตกรรมเรียบร้อยแล้ว",
      });

      // อัพเดทรายการนวัตกรรม
      fetchInnovations();

      // ปิด modal ถ้าเปิดอยู่
      setModalOpen(false);
    } catch (error) {
      console.error("Error approving innovation:", error);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: "ไม่สามารถอนุมัตินวัตกรรมได้",
      });
    }
  };

  // ฟังก์ชันลบนวัตกรรม
  const handleDelete = async (id) => {
    // ถามยืนยันก่อนลบ
    const result = await Swal.fire({
      icon: "warning",
      title: "ยืนยันการลบ",
      text: "คุณแน่ใจหรือไม่ว่าต้องการลบนวัตกรรมนี้? การกระทำนี้ไม่สามารถเรียกคืนได้",
      showCancelButton: true,
      confirmButtonText: "ใช่, ลบเลย",
      cancelButtonText: "ยกเลิก",
      confirmButtonColor: "#d33",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`/innovations/${id}`);

        Swal.fire({
          icon: "success",
          title: "สำเร็จ!",
          text: "ลบนวัตกรรมเรียบร้อยแล้ว",
        });

        // อัพเดทรายการนวัตกรรม
        fetchInnovations();

        // ปิด modal ถ้าเปิดอยู่
        setModalOpen(false);
      } catch (error) {
        console.error("Error deleting innovation:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถลบนวัตกรรมได้",
        });
      }
    }
  };

  // ฟังก์ชันเปิด modal ดูรายละเอียด
  const openDetailModal = (innovation) => {
    setSelectedInnovation(innovation);
    setModalOpen(true);
  };

  // ฟังก์ชันปิด modal
  const closeModal = () => {
    setModalOpen(false);
    setSelectedInnovation(null);
  };

  // สร้าง Component แสดงรายการนวัตกรรม
  const InnovationList = ({ innovations, isPending }) => {
    if (innovations.length === 0) {
      return (
        <div className="empty-state">
          <i className="fas fa-inbox"></i>
          <p>
            {isPending
              ? "ไม่มีนวัตกรรมที่รอการอนุมัติ"
              : "ไม่มีนวัตกรรมที่อนุมัติแล้ว"}
          </p>
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th style={{ width: "5%" }}>#</th>
              <th style={{ width: "15%" }}>รูปภาพ</th>
              <th style={{ width: "25%" }}>ชื่อนวัตกรรม</th>
              <th style={{ width: "15%" }}>ผู้สร้าง</th>
              <th style={{ width: "15%" }}>วิชา/ระดับชั้น</th>
              <th style={{ width: "10%" }}>วันที่สร้าง</th>
              <th style={{ width: "15%" }}>จัดการ</th>
            </tr>
          </thead>
          <tbody>
            {innovations.map((innovation, index) => (
              <tr key={innovation.id}>
                <td>{index + 1}</td>
                <td>
                  <img
                    src={
                      innovation.thumbnail
                        ? `${process.env.REACT_APP_API_URL}/uploads/thumbnails/${innovation.thumbnail}`
                        : "/assets/default-innovation.jpg"
                    }
                    alt={innovation.title}
                    className="table-thumbnail"
                  />
                </td>
                <td>
                  <div className="resource-title">{innovation.title}</div>
                  <div className="resource-description text-muted">
                    {innovation.description &&
                    innovation.description.length > 70
                      ? `${innovation.description.substring(0, 70)}...`
                      : innovation.description}
                  </div>
                </td>
                <td>{innovation.author_name}</td>
                <td>
                  <div>{innovation.subject_name}</div>
                  <small className="text-muted">
                    {innovation.grade_level_name}
                  </small>
                </td>
                <td>{moment(innovation.created_at).format("D MMM YYYY")}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() => openDetailModal(innovation)}
                      title="ดูรายละเอียด"
                    >
                      <i className="fas fa-eye"></i>
                    </button>

                    {isPending && (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => handleApprove(innovation.id)}
                        title="อนุมัติ"
                      >
                        <i className="fas fa-check"></i>
                      </button>
                    )}

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(innovation.id)}
                      title="ลบ"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // แสดง Loading spinner
  if (loading) {
    return (
      <div className="admin-page">
        <div className="container">
          <div className="loading-spinner">
            <i className="fas fa-spinner fa-spin"></i> กำลังโหลดข้อมูล...
          </div>
        </div>
      </div>
    );
  }

  return (
        <div className="admin-page">
      <AdminSidebar user={user} />
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">
            <i className="fas fa-lightbulb"></i> จัดการนวัตกรรม
          </h1>
          <div className="header-actions">
            <button
              className="btn btn-sm btn-secondary"
              onClick={fetchInnovations}
              title="รีเฟรช"
            >
              <i className="fas fa-sync-alt"></i> รีเฟรช
            </button>
          </div>
        </div>

        <div className="admin-tabs">
          <button
            className={`admin-tab ${activeTab === "pending" ? "active" : ""}`}
            onClick={() => setActiveTab("pending")}
          >
            <i className="fas fa-clock"></i> รอการอนุมัติ
            <span className="badge">{pendingInnovations.length}</span>
          </button>
          <button
            className={`admin-tab ${activeTab === "approved" ? "active" : ""}`}
            onClick={() => setActiveTab("approved")}
          >
            <i className="fas fa-check-circle"></i> อนุมัติแล้ว
            <span className="badge">{approvedInnovations.length}</span>
          </button>
        </div>

        <div className="admin-content">
          {activeTab === "pending" ? (
            <InnovationList innovations={pendingInnovations} isPending={true} />
          ) : (
            <InnovationList
              innovations={approvedInnovations}
              isPending={false}
            />
          )}
        </div>

        {/* Modal แสดงรายละเอียดนวัตกรรม */}
        {modalOpen && selectedInnovation && (
          <div className="modal-backdrop" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>{selectedInnovation.title}</h2>
                <button className="modal-close" onClick={closeModal}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="innovation-detail">
                  {selectedInnovation.thumbnail && (
                    <div className="detail-image">
                      <img
                        src={`${process.env.REACT_APP_API_URL}/uploads/thumbnails/${selectedInnovation.thumbnail}`}
                        alt={selectedInnovation.title}
                      />
                    </div>
                  )}

                  <div className="detail-meta">
                    <div className="meta-item">
                      <i className="fas fa-user"></i> ผู้สร้าง:{" "}
                      {selectedInnovation.author_name}
                    </div>
                    <div className="meta-item">
                      <i className="fas fa-folder"></i> หมวดหมู่:{" "}
                      {selectedInnovation.category_name}
                    </div>
                    <div className="meta-item">
                      <i className="fas fa-book"></i> วิชา:{" "}
                      {selectedInnovation.subject_name}
                    </div>
                    <div className="meta-item">
                      <i className="fas fa-graduation-cap"></i> ระดับชั้น:{" "}
                      {selectedInnovation.grade_level_name}
                    </div>
                    <div className="meta-item">
                      <i className="fas fa-calendar"></i> วันที่สร้าง:{" "}
                      {moment(selectedInnovation.created_at).format(
                        "D MMMM YYYY"
                      )}
                    </div>
                  </div>

                  <div className="detail-section">
                    <h3>รายละเอียด</h3>
                    <p>{selectedInnovation.description}</p>
                  </div>

                  <div className="detail-section">
                    <h3>เนื้อหา</h3>
                    <div className="content-box">
                      {selectedInnovation.content}
                    </div>
                  </div>

                  {selectedInnovation.file_path && (
                    <div className="detail-section">
                      <h3>ไฟล์แนบ</h3>
                      <div className="file-attachment">
                        <i className="fas fa-file"></i>
                        <a
                          href={`${process.env.REACT_APP_API_URL}/uploads/${selectedInnovation.file_path}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          ดาวน์โหลดไฟล์
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                {!selectedInnovation.is_approved && (
                  <button
                    className="btn btn-success"
                    onClick={() => handleApprove(selectedInnovation.id)}
                  >
                    <i className="fas fa-check"></i> อนุมัติ
                  </button>
                )}
                <button
                  className="btn btn-danger"
                  onClick={() => handleDelete(selectedInnovation.id)}
                >
                  <i className="fas fa-trash"></i> ลบ
                </button>
                <button className="btn btn-light" onClick={closeModal}>
                  <i className="fas fa-times"></i> ปิด
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminInnovationsPage;
